@let sectionsWithFields = sectionsWithFieldsSg();
@let sectionWithFieldsColumnCountLookup =
  sectionWithFieldsColumnCountLookupSg();
@let fieldsModeColumnCount = fieldsColumnCountSg();
@let fields = fieldsSg();

<div class="atn-mosaic-details">
  @if (sectionsWithFields) {
    @for (section of sectionsWithFields; track $index) {
      <!-- TODO: Try to remove this div -->
      <div>
        <atn-ds-section [name]="section.name">
          <atn-widget-fields
            [fields]="section.fields"
            [columnCount]="sectionWithFieldsColumnCountLookup[$index]"
          />
        </atn-ds-section>
      </div>
    }
  } @else {
    <atn-widget-fields
      [fields]="fields"
      [columnCount]="fieldsModeColumnCount"
    />
  }
</div>
